import { IQPPictureLoadCtrl } from "../qp-picture-loading";
import { AbstractPictureState, ILoadState } from "./abstract-picture-state";
import IMG_LOADINF from "../images/image_loading.svg";

export class PictureLoadingState extends AbstractPictureState {

    public name: ILoadState = "loading";

    constructor() {
        super();
    }

    /**
     * @description 加载过程中设置图片容器样式
     * 
     * 
     */
    public setStyle(imageElem: JQLite, context: IQPPictureLoadCtrl): void {
        const containerElem = imageElem.parent();
        const borderLoadingClass = `${this.animateClassHead}${context.id}`;
        //TODO(图片记载中状态待处理) 在没有传入加载预览图的情况下,显示加载中的图标
        if(!imageElem[0].dataset.thumbnail){
            const elem = imageElem[0] as HTMLImageElement;
            elem.src = IMG_LOADINF;
        }
        // 为父级容器添加边框加载样式
        containerElem.addClass(borderLoadingClass);
        // 添加图片骨架屏加载样式
        containerElem.addClass(this.skeletonStyle);
    }

    /**
     * @description 清除当前状态样式,在切换状态前被调用
     * 
     */
    public cleanStyle(imageElem: JQLite, context: IQPPictureLoadCtrl): void {
        const containerElem = imageElem.parent();
        const borderLoadingClass = `${this.animateClassHead}${context.id}`;
        // 清楚边框loading样式
        containerElem.removeClass(borderLoadingClass);
        // 清楚图片骨架屏样式
        containerElem.removeClass(this.skeletonStyle);
    }


    /**
     * @description 设置当前状态下可用方法,在切换状态后被调用
     * 
     */
    public setAction(): void { }


    public cleanAction(): void { }
}